module.exports = __webpack_public_path__ + "static/media/step7.2cba6550.png";